import { Injectable } from '@angular/core';
import { GeneratedClientManagerService } from '@cloud-twin-v2/generated/generated-client-manager.service';
import {
  CyclicSimulationParametersDto,
  SimulationActionResponseDto,
  SimulationClient,
  SimulationParametersDto,
} from '@cloud-twin-v2/generated/simulation.generated.client';
import { DateHelperService } from '@common-modules/shared/helpers/date-helper.service';
import { Observable } from 'rxjs';
import { MasterOperatorSimulateData } from './master-operator-simulate-data';

@Injectable()
export class TCSimulationService extends GeneratedClientManagerService {
  private _client: SimulationClient;

  constructor(private _datesHelper: DateHelperService) {
    super();
    this._client = new SimulationClient(this.httpClient, this.baseUrl);
  }
  startSimulation(data: MasterOperatorSimulateData): Observable<SimulationActionResponseDto> {
    const { cyclic, timeStepMax, timeStepMin, instanceId, snapshotId, scenarioIds } = data;

    if (cyclic) {
      const { cycle, period } = data;
      const params = new CyclicSimulationParametersDto({
        snapshotId,
        timeStepMax,
        timeStepMin,
        cycle,
        period,
        scenarioIds,
      });
      return this._client.startCyclicSimulation(instanceId, params);
    } else {
      const { date, startTime, stopTime } = data;

      const dateNoTime = this._datesHelper.getDateNoTime(date);

      const params = new SimulationParametersDto({
        snapshotId,
        timeStepMax,
        timeStepMin,
        date: dateNoTime,
        startDate: startTime,
        stopDate: stopTime,
        scenarioIds,
      });
      return this._client.startSimulation(instanceId, params);
    }
  }

  stopSimulation(instanceId: string): Observable<SimulationActionResponseDto> {
    const context = this.buildHttpContext({ avoid: true });
    return this._client.stoptSimulation(instanceId, context);
  }
}
